import { Button, Dialog, DialogContent, DialogTitle, IconButton, styled } from "@mui/material";
import { FC, useState } from "react";
import ChangeNote from "./ChangeNote";
import CloseIcon from '@mui/icons-material/Close';

const BootstrapDialog = styled(Dialog)(({ theme }) => ({
    '& .MuiDialogContent-root': {
        padding: theme.spacing(2),
    },
    '& .MuiDialogActions-root': {
        padding: theme.spacing(1),
    },
}));
export interface DialogTitleProps {
    id: string;
    children?: React.ReactNode;
    onClose: () => void;
};

function BootstrapDialogTitle(props: DialogTitleProps) {
    const { children, onClose, ...other } = props;

    return (
        <DialogTitle sx={ { m: 0, p: 2 } } { ...other }>
            { children }
            { onClose ? (
                <IconButton
                    aria-label="close"
                    onClick={ onClose }
                    sx={ {
                        position: 'absolute',
                        right: 8,
                        top: 8,
                        color: (theme) => theme.palette.grey[ 500 ],
                    } }
                >
                    <CloseIcon />
                </IconButton>
            ) : null }
        </DialogTitle>
    );
}

const Footer: FC = () => {
    const [ open, setOpen ] = useState(false);

    const handleClickOpen = () => {
        setOpen(true);
    };

    const handleClose = () => {
        setOpen(false);
    };

    return (
        <div className='footer'>
            <div>
                if there's any features you'd like to request send me a DM at <a href='https://twitter.com/GENGEE_'>@GENGEE_</a>
                <br />
                <Button variant="outlined" onClick={ handleClickOpen }>
                    Change Notes
                </Button>
                <BootstrapDialog
                    open={ open }
                    onClose={ handleClose }
                    aria-labelledby="alert-dialog-title"
                    aria-describedby="alert-dialog-description"
                    fullWidth={ true }
                    maxWidth={ 'sm' }
                >
                    <BootstrapDialogTitle id="customized-dialog-title" onClose={ handleClose }>
                        Change History
                    </BootstrapDialogTitle>
                    <DialogContent dividers>
                        <ChangeNote title="1/6/2023 v1.6" notes={ [ 'Add Win / Loss toggle' ] } />
                        <ChangeNote title="1/6/2023 v1.5" notes={ [ 'Bring back full functionality', 'Fix networking issues' ] } />
                        <ChangeNote title="1/6/2023 v1.4" notes={ [ 'Bring back website temporarialy' ] } />
                        <ChangeNote title="1/6/2023 v1.3" notes={ [ 'Fix for overlay network requests building up' ] } />
                        <ChangeNote title="1/6/2023 v1.2" notes={ [ 'Revert change to timer to help out slippi services' ] } />
                        <ChangeNote title="1/6/2023 v1.1" notes={ [ 'Change refresh timer from 5 minutes to 1 minute' ] } />
                    </DialogContent>
                </BootstrapDialog>
            </div>
        </div>
    );
};

export default Footer;